import { ADD_MULTIPLE_TAGS } from './actiontypes';
import { getAll } from '../../api/Api';

function addMultipleTagsAction(tags) {
  return {
    type: ADD_MULTIPLE_TAGS,
    tags,
  };
}

function fetchAllTagsActionCreator() {
  return (dispatch, getState) => {
    const state = getState();
    const tags = state.entities.tags.allIds;
    const { jwt } = state.user;

    // if the equiptypes were loaded recently, abort fetch
    if (tags && tags.length > 0) {
      return Promise.resolve();
    }

    const request = getAll(jwt, 'tags').then(
      (response) => {
        dispatch(addMultipleTagsAction(response));
      },
      // eslint-disable-next-line no-console
      (error) => console.log(error)
    );
    return request;
  };
}

export default fetchAllTagsActionCreator;
